import React, { useState } from 'react';
import { Dialog } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { closeClientsDialog, selectClientsDialog } from '../../stateManagement/clientsDialogSlice';
import { AppDispatch } from '../../stateManagement/store';

import ClientList from './ClientList';

const ClientListDialog: React.FC = () => {

    const clientsDialog = useSelector(selectClientsDialog);

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch<AppDispatch>();

    const handleClose = () => {
        dispatch(closeClientsDialog());
    };

    return (
        <Dialog
            open={clientsDialog.open}
            onClose={() => dispatch(closeClientsDialog())}
            fullWidth
            fullScreen={true}
        >
            <ClientList state={clientsDialog.open ? 'mount' : 'unmount'} loading={loading} setLoading={setLoading} handleClose={handleClose} showInfoToggleButton={true} />
        </Dialog>
    );
};

export default ClientListDialog;
